import { NAV } from '@/content/site';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border">
      <div className="container-custom py-16">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <a href="/" className="flex items-center gap-2.5" aria-label="AGICAFET home">
              <img src="/img/agicafet-logo-72.webp" width={72} height={72} alt="" className="h-9 w-9" />
              <span className="text-base font-semibold tracking-tight text-foreground">AGICAFET</span>
            </a>
            <p className="mt-4 text-[15px] leading-relaxed text-muted-foreground">
              Private AI that works where you are: Local, Hybrid and Physical AI, built in Thailand. Makers of
              PreMize.
            </p>
          </div>

          <nav aria-label="Footer">
            <ul className="grid grid-cols-2 gap-x-12 gap-y-3 text-[15px] sm:grid-cols-3">
              {NAV.map((item) => (
                <li key={item.id}>
                  <a href={`/#${item.id}`} className="text-muted-foreground transition-colors hover:text-foreground">
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="/#faq" className="text-muted-foreground transition-colors hover:text-foreground">
                  FAQ
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-14 flex flex-col gap-4 text-[13px] leading-relaxed text-muted-foreground">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <p>© {year} AGICAFET. All rights reserved.</p>
            <a href="/cookie-policy" className="transition-colors hover:text-foreground">
              Cookie policy
            </a>
          </div>
          <p className="max-w-4xl text-muted-foreground/80">
            NVIDIA, the NVIDIA logo, DGX, Jetson, Isaac, TensorRT and NVIDIA Inception are trademarks and/or
            registered trademarks of NVIDIA Corporation in the U.S. and other countries. Alibaba Cloud and Qwen
            are trademarks of Alibaba Group. Other names may be trademarks of their respective owners.
          </p>
        </div>
      </div>
    </footer>
  );
}
